{
  "static-content-online-booking-process": {
    "buttons": {},
    "text": {
      "title": "Réserver en ligne est un jeu d'enfant !",
      "description": "Trouvez le salon de votre choix et sélectionnez le service, la date et l'heure qui vous conviennent. Confirmez vos coordonnées et le tour est joué !",
      "step-confirm-title": "C'est tout",
      "step-confirm-description": "Vous recevrez instantanément une confirmation de réservation et vous serez prêt",
      "step-find-salon-title": "Trouver un salon",
      "step-find-salon-description": "Trouver le salon par lieu, par traitement ou par date",
      "step-select-date-title": "Sélectionner la date et l'heure",
      "step-select-date-description": "Vous pouvez sélectionner n'importe quelle date et heure disponible",
      "step-select-service-title": "Sélectionner un service",
      "step-select-service-description": "Choisissez votre service préféré"
    }
  }
}
